import { Link, isRouteErrorResponse, useRouteError } from "react-router";
import { Seo } from "./Seo";

function getErrorContent(error: unknown) {
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return {
        code: "404",
        title: "Seite nicht gefunden",
        description: "Die angeforderte Seite existiert nicht oder wurde verschoben.",
      };
    }

    return {
      code: String(error.status),
      title: "Seite gerade nicht verfügbar",
      description:
        "Beim Laden ist ein technisches Problem aufgetreten. Bitte versuchen Sie es in wenigen Minuten erneut.",
    };
  }

  return {
    code: "Fehler",
    title: "Seite gerade nicht verfügbar",
    description:
      "Beim Laden ist ein technisches Problem aufgetreten. Bitte laden Sie die Seite neu oder versuchen Sie es später erneut.",
  };
}

export function RouteErrorPage() {
  const error = useRouteError();
  const content = getErrorContent(error);

  return (
    <div className="min-h-screen bg-stone-50 py-24 text-gray-950">
      <Seo
        title={content.title}
        description={content.description}
        noIndex
      />

      <section className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <p className="text-sm font-medium uppercase tracking-[0.2em] text-gray-500">{content.code}</p>
        <h1 className="mt-4 text-4xl leading-tight lg:text-5xl">{content.title}</h1>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-gray-700">
          {content.description}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center border border-black bg-black px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-gray-800"
          >
            Seite neu laden
          </button>
          <Link
            to="/"
            className="inline-flex items-center justify-center border border-black px-6 py-3 text-sm font-medium text-black transition-colors hover:bg-black hover:text-white"
          >
            Zur Startseite
          </Link>
        </div>
      </section>
    </div>
  );
}
